import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const PrivacyPolicy = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white">
      <div className="container mx-auto px-4 py-12 max-w-4xl">
        <button
          onClick={() => navigate('/')}
          className="flex items-center gap-2 text-green-600 hover:text-green-700 mb-8"
        >
          <ArrowLeft className="w-5 h-5" />
          Torna alla home
        </button>

        <h1 className="text-4xl font-bold mb-8">Privacy Policy</h1>
        <p className="text-sm text-gray-500 mb-8">Ultimo aggiornamento: {new Date().toLocaleDateString('it-IT')}</p>

        <div className="prose prose-lg max-w-none space-y-6">
          <section>
            <h2 className="text-2xl font-bold mb-4">1. Titolare del Trattamento</h2>
            <p>
              Il Titolare del trattamento dei dati è <strong>Revogreen Srl</strong>, con sede legale in Via Roma 44B, Mozzecane (VR), Italia.
            </p>
            <p>
              <strong>Email:</strong> info@revogreenitalia.com<br />
              <strong>Telefono:</strong> 800 86 46 21
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4">2. Dati Personali Raccolti</h2>
            <p>Raccogliamo i seguenti dati personali quando compili il form di richiesta sopralluogo:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li><strong>Dati identificativi:</strong> Nome, cognome, email, numero di telefono</li>
              <li><strong>Dati abitazione:</strong> Provincia, tipologia abitazione, status proprietà</li>
              <li><strong>Dati tecnici:</strong> Descrizione del problema del tetto</li>
              <li><strong>Dati di navigazione:</strong> Indirizzo IP, tipo di browser, pagine visitate (tramite Google Analytics e Meta Pixel)</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4">3. Finalità del Trattamento</h2>
            <p>I tuoi dati personali vengono trattati per le seguenti finalità:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li><strong>Erogazione servizi:</strong> Per contattarti e organizzare il sopralluogo gratuito</li>
              <li><strong>Marketing diretto:</strong> Per inviarti comunicazioni commerciali sui nostri servizi (previo consenso)</li>
              <li><strong>Analisi:</strong> Per migliorare il nostro sito web e i nostri servizi (Google Analytics)</li>
              <li><strong>Pubblicità:</strong> Per mostrarti annunci pertinenti su Google e Meta/Facebook (previo consenso)</li>
              <li><strong>Obblighi legali:</strong> Per adempiere a obblighi di legge, regolamenti e normative</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4">4. Base Giuridica</h2>
            <p>Il trattamento dei dati si basa su:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li><strong>Consenso:</strong> Per cookie di marketing e comunicazioni commerciali (Art. 6.1.a GDPR)</li>
              <li><strong>Esecuzione contrattuale:</strong> Per fornire i servizi richiesti (Art. 6.1.b GDPR)</li>
              <li><strong>Legittimo interesse:</strong> Per analisi statistiche e miglioramento del servizio (Art. 6.1.f GDPR)</li>
              <li><strong>Obbligo legale:</strong> Per adempimenti fiscali e contabili (Art. 6.1.c GDPR)</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4">5. Destinatari dei Dati</h2>
            <p>I tuoi dati possono essere comunicati a:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li><strong>Google LLC:</strong> Per servizi di analytics e pubblicità (Google Analytics, Google Ads)</li>
              <li><strong>Meta Platforms Ireland Limited:</strong> Per servizi di pubblicità (Facebook Pixel, Instagram Ads)</li>
              <li><strong>Resend:</strong> Per l'invio di notifiche email interne</li>
              <li><strong>Fornitori di servizi tecnici:</strong> Hosting, manutenzione sito web</li>
              <li><strong>Autorità competenti:</strong> Quando richiesto dalla legge</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4">6. Trasferimento Dati Extra-UE</h2>
            <p>
              Alcuni fornitori di servizi (Google, Meta) potrebbero trasferire i tuoi dati al di fuori dell'Unione Europea. 
              Questi trasferimenti sono regolati da clausole contrattuali standard approvate dalla Commissione Europea e da 
              adeguate garanzie di protezione dei dati.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4">7. Periodo di Conservazione</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li><strong>Dati lead:</strong> Conservati per 2 anni dalla raccolta o fino a revoca del consenso</li>
              <li><strong>Dati clienti:</strong> Conservati per 10 anni per obblighi fiscali e contabili</li>
              <li><strong>Cookie analytics:</strong> Dati aggregati per 26 mesi</li>
              <li><strong>Cookie marketing:</strong> Fino a revoca del consenso, massimo 12 mesi</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4">8. Diritti dell'Interessato</h2>
            <p>Hai il diritto di:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li><strong>Accesso:</strong> Ottenere conferma dell'esistenza dei tuoi dati e una copia degli stessi</li>
              <li><strong>Rettifica:</strong> Correggere dati inesatti o incompleti</li>
              <li><strong>Cancellazione:</strong> Richiedere la cancellazione dei dati (diritto all'oblio)</li>
              <li><strong>Limitazione:</strong> Limitare il trattamento in determinati casi</li>
              <li><strong>Portabilità:</strong> Ricevere i dati in formato strutturato</li>
              <li><strong>Opposizione:</strong> Opporti al trattamento per motivi legittimi</li>
              <li><strong>Revoca consenso:</strong> Revocare il consenso in qualsiasi momento</li>
              <li><strong>Reclamo:</strong> Presentare reclamo all'Autorità Garante (www.garanteprivacy.it)</li>
            </ul>
            <p className="mt-4">
              Per esercitare i tuoi diritti, contattaci via email a{' '}
              <a href="mailto:privacy@revogreenitalia.com" className="text-green-600 underline">
                privacy@revogreenitalia.com
              </a>
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4">9. Sicurezza dei Dati</h2>
            <p>
              Adottiamo misure tecniche e organizzative appropriate per proteggere i tuoi dati personali da accesso non autorizzato, 
              perdita, distruzione o alterazione, inclusi crittografia SSL, firewall, backup regolari e controllo accessi.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4">10. Modifiche alla Privacy Policy</h2>
            <p>
              Ci riserviamo il diritto di modificare questa Privacy Policy in qualsiasi momento. 
              Le modifiche saranno pubblicate su questa pagina con la data di aggiornamento. 
              Ti consigliamo di consultare regolarmente questa pagina.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4">11. Contatti</h2>
            <p>
              Per qualsiasi domanda riguardante il trattamento dei tuoi dati personali, puoi contattarci:
            </p>
            <div className="bg-gray-50 p-6 rounded-lg mt-4">
              <p><strong>Revogreen Srl</strong></p>
              <p>Via Roma 44B, Mozzecane (VR), Italia</p>
              <p>Email: <a href="mailto:info@revogreenitalia.com" className="text-green-600 underline">info@revogreenitalia.com</a></p>
              <p>Privacy: <a href="mailto:privacy@revogreenitalia.com" className="text-green-600 underline">privacy@revogreenitalia.com</a></p>
              <p>Telefono: 800 86 46 21</p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
